import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
function useScrollThreshold(fetchNextPage, hasNextPage, isFetchingNextPage) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] !== fetchNextPage || $[1] !== hasNextPage || $[2] !== isFetchingNextPage) {
    t0 = () => {
      const handleScroll = () => {
        if (isFetchingNextPage) {
          return;
        }
        const documentHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY;
        const distanceFromBottom = documentHeight - (windowHeight + scrollY);
        const percentageFromBottom = distanceFromBottom / documentHeight;
        if (percentageFromBottom <= 0.4 && hasNextPage) {
          fetchNextPage();
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    t1 = [fetchNextPage, hasNextPage, isFetchingNextPage];
    $[0] = fetchNextPage;
    $[1] = hasNextPage;
    $[2] = isFetchingNextPage;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}
export default useScrollThreshold;